export const locales = ["nl", "en", "de", "fr", "es"] as const;

export type Locale = (typeof locales)[number];

export const defaultLocale: Locale = "nl";

export const localeMeta: Record<
  Locale,
  { label: string; og: string; html: string; flag: string }
> = {
  nl: { label: "Nederlands", og: "nl_NL", html: "nl", flag: "🇳🇱" },
  en: { label: "English", og: "en_GB", html: "en", flag: "🇬🇧" },
  de: { label: "Deutsch", og: "de_DE", html: "de", flag: "🇩🇪" },
  fr: { label: "Français", og: "fr_FR", html: "fr", flag: "🇫🇷" },
  es: { label: "Español", og: "es_ES", html: "es", flag: "🇪🇸" },
};

export function isLocale(value: string): value is Locale {
  return (locales as readonly string[]).includes(value);
}

function withHtmlSlash(path: string): string {
  if (path === "/" || path === "") return "/";
  const prefix = path.startsWith("/") ? path : `/${path}`;
  if (/\.[a-z0-9]+$/i.test(prefix)) return prefix;
  return prefix.endsWith("/") ? prefix : `${prefix}/`;
}

export function localePath(locale: Locale, path = "/"): string {
  const suffix = withHtmlSlash(path);
  return suffix === "/" ? `/${locale}/` : `/${locale}${suffix}`;
}

export function stripLocalePrefix(pathname: string): string {
  const match = pathname.match(/^\/(nl|en|de|fr|es)(\/.*)?$/);
  if (!match) return pathname === "/" ? "/" : pathname;
  return match[2] && match[2].length > 0 ? match[2] : "/";
}
